import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phone',
    standalone: false
})
export class PhonePipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    transform(value: any, args?: any): any {
        if (!value) {
            return '';
        }

        value = String(value);

        switch (value.length) {
            case 8:
                return value.replace(/(\d{4})(\d{4})/g, '\$1-\$2');
            case 9:
                return value.replace(/(\d{5})(\d{4})/g, '\$1-\$2');
            default:
                return value;
        }
    }
}
